import { FileResponse } from "./FileResponse.model";

export class ParticipationHrsDocs {
  constructor(
    public referralId?: number,
    public activityId?: number,
    public participationHrsId?: number,
    public fileResponses?: FileResponse[],
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/ParticipationHrsDocs.model.ts